export default __webpack_public_path__ + "390fa345c2f26c6ea382d4e8a3d0b9e3.png";